/**
 * Firebase Initialization
 * 
 * Initializes Firebase SDK with the configuration from firebase.config.ts
 */

import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { firebaseConfig } from '../../config/firebase.config';

// Initialize Firebase
const firebaseApp: FirebaseApp = getApps().length === 0 
  ? initializeApp(firebaseConfig) 
  : getApps()[0];

// Initialize services
export const auth: Auth = getAuth(firebaseApp);
export const db: Firestore = getFirestore(firebaseApp);
export const storage: FirebaseStorage = getStorage(firebaseApp);

// Export the app for advanced configurations
export default firebaseApp;

/**
 * Firebase service regions
 * - Firestore: us-central1 (default)
 * - Storage: us-central1 (default)
 * - Authentication: us-central1 (default)
 */

// Firestore settings (optional configuration)
export const firestoreSettings = {
  // Cache size in bytes (default: 40MB)
  cacheSizeBytes: 40 * 1024 * 1024,
  // Enable persistence
  persistence: true,
};

// Apply Firestore settings if needed
// Uncomment the following lines to apply custom settings:
// import { enableIndexedDbPersistence } from 'firebase/firestore';
// enableIndexedDbPersistence(db).catch((err) => {
//   if (err.code === 'failed-precondition') {
//     console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time.');
//   } else if (err.code === 'unimplemented') {
//     console.warn('The current browser does not support persistence.');
//   }
// });